var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Prop } from 'vue-property-decorator';
import { User } from '@/models/User';
import Roster from '@/components/roster/Roster';
import NotificationsCard from '@/components/notifications-card/NotificationsCard';
import { UserSubject } from '@/models/UserSubject';
import DataTable from '@/components/data-table/DataTable';
import { Guardian as GuardianModel } from '@/models/Guardian';
import LoaderCard from '@/components/loader-card/LoaderCard';
import { formatDate as format } from '@/support/String';
import { excludeRoles } from '@/support/ExcludeRoles';
let Dashboard = class Dashboard extends Vue {
    constructor() {
        super(...arguments);
        this.guardian = new GuardianModel();
        this.students = [];
        this.activeStudentTab = '';
        this.relationships = [];
        this.isLoading = true;
        this.guardian_can_see_student_finished = true;
        this.guardian_can_see_student_roster = true;
        this.guardian_can_use_chat_functions = true;
    }
    get userSubjectsTableOptions() {
        return {
            sort: {
                key: 'updated',
                order: 'DESC',
            },
            headers: [
                {
                    text: this.$tc('subject.title', 2),
                    value: 'name',
                    action: `/students/${this.activeTabUserId}/idp`,
                },
                {
                    text: this.$tc('subject.area.title', 2),
                    value: 'parent',
                    transform: this.areaName,
                },
                {
                    text: this.$tc('subject.topic.title', 2),
                    value: 'parent',
                    transform: this.parentName,
                },
                {
                    text: this.$tc('idp.status.finished', 2),
                    value: 'updated_at',
                    transform: (date) => {
                        return format(date, 'yyyy-LL-dd');
                    },
                },
            ],
            actions: [
                {
                    type: 'view',
                    label: 'view',
                    icon: 'remove_red_eye',
                    action: `/students/${this.activeTabUserId}`,
                },
            ],
            model: new UserSubject()
                .user(this.activeTabUserId)
                .include('parent')
                .filter({ statuses: 'finished', trashed: true }),
        };
    }
    get activeTabUserId() {
        const relationshipId = this.activeStudentTab.replace('tabs-', '');
        const relationship = this.relationships.find((relationship) => {
            return relationship.id === relationshipId;
        });
        if (!relationship || !relationship.user) {
            return '';
        }
        return relationship.user.id || '';
    }
    get exclude() {
        return excludeRoles[this.$store.state.version].scoolUsers.dashboard.includes(this.$store.state.Auth.roles[0].id);
    }
    mounted() {
        this.initialize();
        this.setSettings();
    }
    initialize() {
        this.isLoading = true;
        new GuardianModel()
            .include(['relationships'])
            .filter('relationship', 'child')
            .find(this.user.id)
            .then((guardian) => {
            this.guardian = guardian;
            const relationships = guardian.relationships;
            if (relationships.length > 0) {
                this.activeStudentTab = `tabs-${relationships[0].id}`;
                relationships.forEach((relationship) => {
                    this.relationships.push(relationship);
                });
            }
            this.isLoading = false;
        })
            .finally(() => {
            this.isLoading = false;
        });
    }
    areaName(element) {
        if (!element.id) {
            return '';
        }
        let name = '';
        this.$store.state.curriculum.subjects.forEach((area) => {
            if (!area.children) {
                return;
            }
            area.children.forEach((topic) => {
                if (topic.id === element.id && area.name) {
                    name = area.name;
                }
            });
        });
        return name;
    }
    parentName(element) {
        return element.name ? element.name : '';
    }
    isVersion(version) {
        // No Strict comparison because some we have a number and sometimes a sting...
        return version == this.$store.state.version;
    }
    setSettings() {
        if (this.$store.state.Auth.isGuardian) {
            const guardianCanSeeStudentFinished = this.$store.state.settings.find((setting) => setting.key === 'guardian_can_see_student_finished');
            if (guardianCanSeeStudentFinished) {
                this.guardian_can_see_student_finished = guardianCanSeeStudentFinished.value === '1' || guardianCanSeeStudentFinished.value === true ? true : false;
            }
            const guardianCanSeeStudentRoster = this.$store.state.settings.find((setting) => setting.key === 'guardian_can_see_student_roster');
            if (guardianCanSeeStudentRoster) {
                this.guardian_can_see_student_roster = guardianCanSeeStudentRoster.value === '1' || guardianCanSeeStudentRoster.value === true ? true : false;
            }
            const guardianCanUseChatFunctions = this.$store.state.settings.find((setting) => setting.key === 'guardian_can_use_chat_functions');
            if (guardianCanUseChatFunctions) {
                this.guardian_can_use_chat_functions = guardianCanUseChatFunctions.value === '1' || guardianCanUseChatFunctions.value === true ? true : false;
            }
        }
    }
};
__decorate([
    Prop({ default: new User() }),
    __metadata("design:type", typeof (_a = typeof User !== "undefined" && User) === "function" ? _a : Object)
], Dashboard.prototype, "user", void 0);
Dashboard = __decorate([
    Component({
        components: {
            DataTable,
            NotificationsCard,
            Roster,
            LoaderCard,
        },
    })
], Dashboard);
export default Dashboard;
